  /* eslint-disabled */

export default class QuestionChoiceExtend {


  constructor (object?: any) {
  }

}
